export const DATA_TYPES = {
    PULL: 'pull',
    STREAM: 'stream'
};
export const DATA_EVENTS = {
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
    AFTER_SUBSCRIBE: 'after_subscribe',
    AFTER_UNSUBSCRIBE: 'after_unsubscribe',
    DATA: 'data',
    TOKEN_EXPIRED: 'tokenExpired',
    TOKEN_RENEWED: 'tokenRenewed'
};

export const REQUEST_TIMEOUT = 30000;

export const PULLING_FREQUENCY = 30000;

export const GROUP_SYMBOL_QUANTITY = 100;

export const TOKEN_EXPIRED_TRIGGERED_MAX_COUNT = 5;

export const PUSH_CONNECT_RETRY_MAX_COUNT = 5;
